import React from "react";

export const CategoryFour = () => <h1>CategoryFour</h1>
